import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';

export enum SectionType {
  LifeArea = 'life-area',
  Goal = 'goal',
  Section = 'goal-section',
}

export type Section = {
  id: ID;
  type: SectionType;
  items: Task[];
  parentId?: ID;
};

export enum TreeNodeType {
  LifeArea = 'life-area',
  Goal = 'goal',
  Section = 'goal-section',
  Task = 'task',
}

export type TreeNode = {
  // mui basics
  id: ID;
  label: string;
  children?: TreeNode[];
  // additional info
  type: TreeNodeType;
};
